import { FormItemTypes } from '@bimser/core';
import { LayoutStructureItem, NormalizedLayoutStructureItems } from '../../../common/entities';

const tabsRelated = [FormItemTypes.EControlTypes.Tabs, FormItemTypes.EControlTypes.Collapse];

export const getParentTabsCount = (
	viewGetter: NormalizedLayoutStructureItems | ((id: string) => LayoutStructureItem),
	id: string,
	isSelf: boolean = true
) => {
	let times = 0;

	const control =
		typeof viewGetter === 'function' ? viewGetter(id) : viewGetter.entities.items.get(id);

	if (control) {
		if (tabsRelated.includes(control.type as FormItemTypes.EControlTypes) && !isSelf) {
			times++;
		}

		const parent = control.parentId
			? typeof viewGetter === 'function'
				? viewGetter(control.parentId)
				: viewGetter.entities.items.get(control.parentId)
			: null;

		if (parent) {
			times += getParentTabsCount(viewGetter, parent.id, false);
		}
	}

	return times;
};
